import { Loader2 } from "lucide-react";

export default function LoadingPage() {
  return (
    <div className="min-h-screen bg-[var(--stone-bg)] flex items-center justify-center" data-testid="loading-page">
      <Loader2 className="w-10 h-10 text-[var(--terra)] animate-spin" />
    </div>
  );
}
